import { getQueryParams } from '../helpers/Common';
import reducerRegistry from '../helpers/ReducerRegistry';
import newsAnalysisService from '../../core/services/News/NewsAnalysisService';
import Const from '../news-and-analysis/Const';
import ConstCommon from './../common/Const';
import currentState from './../helpers/CurrentState';
import { formatDate } from '../helpers/FormatDate';

const REDUCER_NAME = 'NEW_AND_ANALYSIS:';

const RESET_STORE_DATA = `${REDUCER_NAME}RESET_STORE_DATA`;

const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const CHANGE_TAB = `${REDUCER_NAME}CHANGE_TAB`;

const GET_AGGREGATOR_NEWS = `${REDUCER_NAME}GET_AGGREGATOR_NEWS`;
const SET_FETCHING_NA = `${REDUCER_NAME}SET_FETCHING_NA`;

const GET_AUTO_NEWS = `${REDUCER_NAME}GET_AUTO_NEWS`;
const SET_FETCHING_AN = `${REDUCER_NAME}SET_AUTO_NEWS`;

const GET_PREMIUM_ANALYSIS = `${REDUCER_NAME}GET_PREMIUM_ANALYSIS`;
const SET_FETCHING_PA = `${REDUCER_NAME}SET_FETCHING_PA`;

const GET_MOST_RECENT = `${REDUCER_NAME}GET_MOST_RECENT`;
const SET_FETCHING_MR = `${REDUCER_NAME}SET_FETCHING_MR`;

const GET_MOST_POPULAR = `${REDUCER_NAME}GET_MOST_POPULAR`;
const SET_FETCHING_MP = `${REDUCER_NAME}SET_FETCHING_MP`;

const GET_RUMORS = `${REDUCER_NAME}GET_RUMORS`;
const SET_FETCHING_R = `${REDUCER_NAME}SET_FETCHING_R`;

const GET_CONTRIBUTOR = `${REDUCER_NAME}GET_CONTRIBUTOR`;
const SET_FETCHING_C = `${REDUCER_NAME}SET_FETCHING_C`;

const GET_NEWS_BY_EXPERT = `${REDUCER_NAME}GET_NEWS_BY_EXPERT`;

const GET_NEWS_FULL_CONTENT = `${REDUCER_NAME}GET_NEWS_FULL_CONTENT`;

const SET_FETCHING_EXPERT_NEWS = `${REDUCER_NAME}SET_FETCHING_EXPERT_NEWS`;

const SET_NEWS_BY_EXPERT_DATA = `${REDUCER_NAME}SET_NEWS_BY_EXPERT_DATA`;

const SET_FILTER_CONDITION = `${REDUCER_NAME}SET_FILTER_CONDITION`;

const SET_TRUST_CONDITION = `${REDUCER_NAME}SET_TRUST_CONDITION`;

const SET_API_PARAMS = `${REDUCER_NAME}SET_API_PARAMS`;

const TOGGLE_NEW_FAVORITE = `${REDUCER_NAME}TOGGLE_NEW_FAVORITE`;

const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;

const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

export { REDUCER_NAME, reducer as default };

let mounted = true;
let currentTotalCount = 0;

const formatTime = (FromDate, ToDate) => {
  return {
    FromDate: formatDate(FromDate, true) || '',
    ToDate: formatDate(ToDate, false) || '',
  };
};

export const resetStoreData = storeName => dispatch => {
  dispatch({
    type: RESET_STORE_DATA,
    payload: {
      storeName,
    },
  });
};

export const setTrustCondition = (arrCondition = []) => dispatch => {
  dispatch(fetchRumors());
  dispatch({
    type: SET_TRUST_CONDITION,
    payload: {
      arrCondition,
    },
  });
};

const checkIsSearching = storeName => (dispatch, getState) => {
  const apiParams = getState()[REDUCER_NAME][storeName].apiParams;
  const { Page } = apiParams;
  if (Page === 1) {
    dispatch({
      type: RESET_STORE_DATA,
      payload: {
        storeName,
      },
    });
  }
};

export const setAPIParams = (
  tab = { parentTab: 1, childTab: 1 },
  apiParams = {},
) => dispatch => {
  const { parentTab, childTab } = tab;
  let pageParams =
    parentTab !== 4
      ? Const.TAB_MAPPING[parentTab]
      : Const.TAB_MAPPING[parentTab][childTab];
  dispatch({
    type: SET_API_PARAMS,
    payload: {
      pageParams,
      apiParams,
    },
  });
  if (parentTab === 1) {
    dispatch(checkIsSearching('aggregatorNewsData'));
    dispatch(fetchAggregatorNews());
  }

  if (parentTab === 2) {
    dispatch(checkIsSearching('autoNewsData'));
    dispatch(fetchAutoNews());
  }

  if (parentTab === 3) {
    dispatch(checkIsSearching('premiumAnalysisData'));
    dispatch(fetchPremiumAnalysis());
  }

  if (parentTab === 4) {
    if (childTab === 1) {
      dispatch(checkIsSearching('mostRecentData'));
      dispatch(fetchMostRecent());
    }
    if (childTab === 2) {
      dispatch(checkIsSearching('mostPopularData'));
      dispatch(fetchMostPopular());
    }
    if (childTab === 3) {
      dispatch(checkIsSearching('contributorsData'));
      dispatch(fetchContributor());
    }
    if (childTab === 4) dispatch();
  }

  if (parentTab === 5) {
    dispatch(checkIsSearching('rumorsData'));
    dispatch(fetchRumors());
  }
};

export const setFilterCondition = (
  tab = { parentTab: 1, childTab: 0 },
  condition = {},
) => dispatch => {
  const { parentTab, childTab } = tab;
  let page =
    parentTab !== 4
      ? Const.TAB_MAPPING[parentTab]
      : Const.TAB_MAPPING[parentTab][childTab];
  dispatch({
    type: SET_FILTER_CONDITION,
    payload: {
      page,
      condition,
    },
  });
};

export const changeTab = (tabType, tabNumber) => dispatch => {
  currentState.add(ConstCommon.listComponent.News, [tabType], tabNumber);
  dispatch({
    type: CHANGE_TAB,
    payload: {
      tabNumber,
      tabType,
    },
  });
};

export const setFetchingNA = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_NA,
    payload: {
      naStatus: status,
    },
  });
};

export const fetchAggregatorNews = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingNA());
    const apiParams = getState()[REDUCER_NAME].aggregatorNewsData.apiParams;
    const time = formatTime(apiParams.FromDate, apiParams.ToDate);
    apiParams.LastId = 0;
    newsAnalysisService
      .getAggregatorNews({ ...apiParams, ...time })
      .then(response => {
        dispatch(setFetchingNA(false));
        const { items = [], totalCount = 0 } = response;
        currentTotalCount = totalCount;
        if (mounted) {
          dispatch({
            type: GET_AGGREGATOR_NEWS,
            payload: {
              naData: items && items.length ? items : [],
              totalPageNA: Math.ceil(totalCount / apiParams.PageSize),
            },
          });
        }
      })
      .then(err => dispatch(setFetchingNA(false)));
  };
};

export const fetchAggregatorNewsInterval = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingNA());
    const apiParams = getState()[REDUCER_NAME].aggregatorNewsData.apiParams;
    const data = getState()[REDUCER_NAME].aggregatorNewsData.data;
    const time = formatTime(apiParams.FromDate, apiParams.ToDate);
    let apiParamsInterval = {
      Page: 1,
      PageSize: apiParams.PageSize,
      FromDate: apiParams.FromDate,
      ToDate: apiParams.ToDate,
      KeyWord: apiParams.KeyWord,
      LastId: Array.isArray(data) && data.length > 0 ? data[0].newsId : 0,
    };
    console.log('API params: ', apiParams);
    newsAnalysisService
      .getAggregatorNews({ ...apiParamsInterval, ...time })
      .then(response => {
        dispatch(setFetchingNA(false));
        const { items = [] } = response;
        if (mounted) {
          dispatch({
            type: GET_AGGREGATOR_NEWS,
            payload: {
              naData: items && items.length ? items : [],
              totalPageNA: Math.ceil(currentTotalCount / apiParams.PageSize),
            },
          });
        }
      })
      .then(err => dispatch(setFetchingNA(false)));
  };
};

export const setFetchingAN = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_AN,
    payload: {
      anStatus: status,
    },
  });
};

export const fetchAutoNews = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingAN());
    const apiParams = getState()[REDUCER_NAME].autoNewsData.apiParams;
    const time = formatTime(apiParams.FromDate, apiParams.ToDate);
    newsAnalysisService
      .getAutoNews({ ...apiParams, ...time })
      .then(response => {
        dispatch(setFetchingAN(false));
        const { items = [], totalCount = 0 } = response;
        currentTotalCount = totalCount;
        if (mounted) {
          dispatch({
            type: GET_AUTO_NEWS,
            payload: {
              anData: items && items.length ? items : [],
              totalPageAN: Math.ceil(totalCount / apiParams.PageSize),
            },
          });
        }
      })
      .catch(err => dispatch(setFetchingAN(false)));
  };
};

export const fetchAutoNewsInterval = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingAN());
    const apiParams = getState()[REDUCER_NAME].autoNewsData.apiParams;
    const time = formatTime(apiParams.FromDate, apiParams.ToDate);
    const data = getState()[REDUCER_NAME].autoNewsData.data;
    let apiParamsInterval = {
      Page: 1,
      PageSize: apiParams.PageSize,
      FromDate: apiParams.FromDate,
      ToDate: apiParams.ToDate,
      KeyWord: apiParams.KeyWord,
      LastId: Array.isArray(data) && data.length > 0 ? data[0].newsId : 0,
    };
    newsAnalysisService
      .getAutoNews({ ...apiParamsInterval, ...time })
      .then(response => {
        dispatch(setFetchingAN(false));
        const { items = [] } = response;
        if (mounted) {
          dispatch({
            type: GET_AUTO_NEWS,
            payload: {
              anData: items && items.length ? items : [],
              totalPageAN: Math.ceil(currentTotalCount / apiParams.PageSize),
            },
          });
        }
      })
      .catch(err => dispatch(setFetchingAN(false)));
  };
};

export const refreshAutoNews = () => dispatch => {
  dispatch(setFetchingAN());
};

export const setFetchingPA = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_PA,
    payload: {
      paStatus: status,
    },
  });
};

export const fetchPremiumAnalysis = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingPA());
    const apiParams = getState()[REDUCER_NAME].premiumAnalysisData.apiParams;
    const time = formatTime(apiParams.FromDate, apiParams.ToDate);
    newsAnalysisService
      .getPremiumAnalysis({ ...apiParams, ...time })
      .then(response => {
        dispatch(setFetchingPA(false));
        const { items = [], totalCount = 0 } = response;
        if (mounted) {
          dispatch({
            type: GET_PREMIUM_ANALYSIS,
            payload: {
              paData: items && items.length ? items : [],
              totalPagePA: Math.ceil(totalCount / apiParams.PageSize),
            },
          });
        }
      })
      .catch(err => dispatch(setFetchingPA(false)));
  };
};

export const setFetchingC = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_C,
    payload: {
      cStatus: status,
    },
  });
};

export const fetchContributor = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingC());
    const apiParams = getState()[REDUCER_NAME].contributorsData.apiParams;
    newsAnalysisService
      .getContributor(apiParams)
      .then(response => {
        dispatch(setFetchingC(false));
        const { items = [], totalCount = 0 } = response;
        if (mounted) {
          dispatch({
            type: GET_CONTRIBUTOR,
            payload: {
              cData: items && items.length ? items : [],
              totalPageC: Math.ceil(totalCount / apiParams.PageSize),
            },
          });
        }
      })
      .catch(err => dispatch(setFetchingC(false)));
  };
};

export const setFetchingExpertNews = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_EXPERT_NEWS,
    payload: {
      enStatus: status,
    },
  });
};

export const getNewsByExpert = ExpertId => {
  return dispatch => {
    dispatch(setFetchingExpertNews());
    newsAnalysisService
      .getNewsByExpert({ ExpertId, language: 'vi' })
      .then(response => {
        dispatch(setFetchingExpertNews(false));
        const { items = [] } = response;
        dispatch({
          type: GET_NEWS_BY_EXPERT,
          payload: {
            ExpertId,
            listNewsByExpert: items,
          },
        });
      })
      .then(err => dispatch(setFetchingExpertNews(false)));
  };
};

export const getNewsFullContent = NewsId => {
  return dispatch => {
    dispatch(setFetchingExpertNews());
    newsAnalysisService
      .getNewFullContent({ NewsId, language: 'vi' })
      .then(response => {
        dispatch(setFetchingExpertNews());
        const { items = [] } = response;
        dispatch({
          type: GET_NEWS_FULL_CONTENT,
          payload: {
            NewsId,
            currentNewsInfo: items && items.length ? items[0] : {},
          },
        });
      })
      .catch(err => dispatch(setFetchingExpertNews(false)));
  };
};

export const setNewsByExpertData = (newKey, newValue) => {
  return dispatch => {
    dispatch({
      type: SET_NEWS_BY_EXPERT_DATA,
      payload: {
        newKey,
        newValue,
      },
    });
  };
};

export const setFetchingMR = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_MR,
    payload: {
      mrStatus: status,
    },
  });
};

export const fetchMostRecent = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingMR());
    const apiParams = getState()[REDUCER_NAME].mostRecentData.apiParams;
    newsAnalysisService
      .getMostRecent(apiParams)
      .then(response => {
        dispatch(setFetchingMR(false));
        const { items = [], totalCount = 0 } = response;
        if (mounted) {
          dispatch({
            type: GET_MOST_RECENT,
            payload: {
              mrData: items && items.length ? items : [],
              totalPageMR: Math.ceil(totalCount / apiParams.PageSize),
            },
          });
        }
      })
      .catch(err => dispatch(setFetchingMR(false)));
  };
};

export const setFetchingMP = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_MP,
    payload: {
      mpStatus: status,
    },
  });
};

export const fetchMostPopular = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingMP());
    const apiParams = getState()[REDUCER_NAME].mostPopularData.apiParams;
    newsAnalysisService
      .getMostPopular(apiParams)
      .then(response => {
        dispatch(setFetchingMP(false));
        const { items = [], totalCount = 0 } = response;
        if (mounted) {
          dispatch({
            type: GET_MOST_POPULAR,
            payload: {
              mpData: items && items.length ? items : [],
              totalPageMP: Math.ceil(totalCount / apiParams.PageSize),
            },
          });
        }
      })
      .catch(err => dispatch(setFetchingMP(false)));
  };
};

export const setFetchingR = (status = true) => dispatch => {
  dispatch({
    type: SET_FETCHING_R,
    payload: {
      rStatus: status,
    },
  });
};

export const fetchRumors = () => {
  return (dispatch, getState) => {
    dispatch(setFetchingR());
    const apiParams = getState()[REDUCER_NAME].rumorsData.apiParams;
    const time = formatTime(apiParams.FromDate, apiParams.ToDate);
    newsAnalysisService
      .getRumors({ ...apiParams, ...time })
      .then(response => {
        dispatch(setFetchingR(false));
        const { items = [], totalCount = 0 } = response;
        if (mounted) {
          dispatch({
            type: GET_RUMORS,
            payload: {
              rData: items && items.length ? items : [],
              totalPageR: Math.ceil(totalCount / apiParams.PageSize),
            },
          });
        }
      })
      .then(err => dispatch(setFetchingR(false)));
  };
};

const initialState = {
  component: {},
  storesName: {
    1: 'NA_STORE',
    2: 'AN_STORE',
    3: 'PA_STORE',
    4: {
      1: 'MR_STORE',
      2: 'MP_STORE',
      3: 'C_STORE',
    },
    5: 'R_STORE',
  },
  aggregatorNewsData: {
    storeName: 'NA_STORE',
    isShortByFavorite: false,
    totalPage: null,
    data: [],
    isLoading: true,
    filterCondition: {},
    apiParams: {
      Page: 1,
      PageSize: 100,
      FromDate: null,
      ToDate: null,
      KeyWord: null,
    },
  },
  autoNewsData: {
    storeName: 'AN_STORE',
    isShortByFavorite: false,
    totalPage: null,
    data: [],
    isLoading: true,
    filterCondition: {},
    apiParams: {
      Page: 1,
      PageSize: 100,
      FromDate: null,
      ToDate: null,
      KeyWord: null,
    },
  },
  premiumAnalysisData: {
    storeName: 'PA_STORE',
    isShortByFavorite: false,
    totalPage: null,
    data: [],
    isLoading: true,
    filterCondition: {},
    apiParams: {
      Page: 1,
      PageSize: 100,
      FromDate: null,
      ToDate: null,
      KeyWord: null,
    },
  },
  mostRecentData: {
    storeName: 'MR_STORE',
    isShortByFavorite: false,
    totalPage: null,
    data: [],
    isLoading: true,
    filterCondition: {},
    apiParams: {
      Page: 1,
      PageSize: 100,
      FromDate: null,
      ToDate: null,
      KeyWord: null,
    },
  },
  mostPopularData: {
    storeName: 'MP_STORE',
    isShortByFavorite: false,
    totalPage: null,
    data: [],
    isLoading: true,
    filterCondition: {},
    apiParams: {
      Page: 1,
      PageSize: 100,
      FromDate: null,
      ToDate: null,
      KeyWord: null,
    },
  },
  contributorsData: {
    storeName: 'C_STORE',
    isShortByFavorite: false,
    totalPage: null,
    data: [],
    isLoading: true,
    filterCondition: {},
    apiParams: {
      Page: 1,
      PageSize: 100,
      language: 'vi',
      FromDate: null,
      ToDate: null,
      KeyWord: null,
    },
    currentExpert: {
      isLoading: true,
      expertId: null,
      newId: null,
      expertData: [],
      currentNewsInfo: {},
    },
  },
  rumorsData: {
    storeName: 'R_STORE',
    isShortByFavorite: false,
    totalPage: null,
    data: [],
    isLoading: true,
    filterCondition: ['High', 'Medium', 'Low'],
    apiParams: {
      Page: 1,
      PageSize: 100,
      FromDate: null,
      ToDate: null,
      KeyWord: null,
    },
  },
};

const getUniqueNews = arr => {
  const existIds = {};
  const result = [];
  arr.forEach(item => {
    if (!existIds[item.newsId]) {
      result.push(item);
      existIds[item.newsId] = true;
    }
  });

  return result;
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const mapTab = {
        FiinTradeDiary: 3,
        FiinTradeCall: 4,
        AutoNews: 2,
        NewsAggregator: 1,
      };
      const tabFromQuery = mapTab[getQueryParams('tab')];
      mounted = true;
      return {
        ...state,
        ...initialState,
        currentTab: tabFromQuery || 1,
        currentChildTab: 1,
      };

    case RESET_STORE_DATA:
      const { storeName } = action.payload;
      const optionalReset = {};
      if (storeName === 'contributorsData') {
        optionalReset.currentExpert = {
          isLoading: true,
          expertId: null,
          newId: null,
          expertData: [],
          currentNewsInfo: {},
        };
      }
      optionalReset.apiParams = state[storeName].apiParams;
      optionalReset.apiParams.Page = 1;
      optionalReset.apiParams.FromDate = null;
      optionalReset.apiParams.ToDate = null;
      return {
        ...state,
        [storeName]: {
          ...state[storeName],
          data: [],
          ...optionalReset,
        },
      };

    case UNMOUNT_COMPONENT:
      mounted = false;
      return {};

    case SET_TRUST_CONDITION:
      const { arrCondition } = action.payload;

      return {
        ...state,
        rumorsData: {
          ...state.rumorsData,
          filterCondition: arrCondition,
        },
      };

    case TOGGLE_NEW_FAVORITE:
      const { newIndex, value, tabData } = action.payload;
      const newPosition = [...state[tabData].data].findIndex(
        item => item.newsId === newIndex,
      );
      return {
        ...state,
        [tabData]: {
          ...state[tabData],
          data: [
            ...state[tabData].data.slice(0, newPosition),
            {
              ...state[tabData].data[newPosition],
              isFavorite: !value,
            },
            ...state[tabData].data.slice(newPosition + 1),
          ],
        },
      };

    case SET_API_PARAMS:
      const { apiParams, pageParams } = action.payload;
      return {
        ...state,
        [pageParams]: {
          ...state[pageParams],
          apiParams: {
            ...state[pageParams].apiParams,
            ...apiParams,
          },
        },
      };

    case SET_FILTER_CONDITION:
      const { page, condition } = action.payload;

      let cloneFilterCondition = {
        ...state[page].filterCondition,
        [condition.key]: condition.value,
      };

      for (var propName in cloneFilterCondition) {
        if (
          cloneFilterCondition[propName] === null ||
          cloneFilterCondition[propName] === undefined
        ) {
          delete cloneFilterCondition[propName];
        }
      }

      return {
        ...state,
        [page]: {
          ...state[page],
          filterCondition: cloneFilterCondition,
        },
      };
    case CHANGE_TAB:
      const { tabNumber, tabType } = action.payload;
      const optionState = {};
      // reset child tab if change parent tab
      if (tabType === 'currentTab') {
        optionState.currentChildTab = 1;
      }
      return {
        ...state,
        [tabType]: tabNumber,
        ...optionState,
      };
    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };
    case GET_AGGREGATOR_NEWS:
      const { naData, totalPageNA } = action.payload;
      return {
        ...state,
        aggregatorNewsData: {
          ...state.aggregatorNewsData,
          data: [...naData, ...state.aggregatorNewsData.data],
          isLoading: false,
          totalPage: totalPageNA,
        },
      };
    case SET_FETCHING_NA:
      const { naStatus } = action.payload;
      return {
        ...state,
        aggregatorNewsData: {
          ...state.aggregatorNewsData,
          isLoading: naStatus,
        },
      };
    case GET_AUTO_NEWS:
      const { anData, totalPageAN } = action.payload;

      return {
        ...state,
        autoNewsData: {
          ...state.autoNewsData,
          data: [...anData, ...state.autoNewsData.data],
          isLoading: false,
          totalPage: totalPageAN,
        },
      };
    case SET_FETCHING_AN:
      const { anStatus } = action.payload;
      return {
        ...state,
        autoNewsData: {
          ...state.autoNewsData,
          isLoading: anStatus,
        },
      };
    case GET_PREMIUM_ANALYSIS:
      const { paData, totalPagePA } = action.payload;
      return {
        ...state,
        premiumAnalysisData: {
          ...state.premiumAnalysisData,
          data: [...state.premiumAnalysisData.data, ...paData],
          isLoading: false,
          totalPage: totalPagePA,
        },
      };
    case SET_FETCHING_PA:
      const { paStatus } = action.payload;
      return {
        ...state,
        premiumAnalysisData: {
          ...state.premiumAnalysisData,
          isLoading: paStatus,
        },
      };
    case GET_CONTRIBUTOR:
      const { cData, totalPageC } = action.payload;
      return {
        ...state,
        contributorsData: {
          ...state.contributorsData,
          data: [...state.contributorsData.data, ...cData],
          isLoading: false,
          totalPage: totalPageC,
        },
      };
    case SET_FETCHING_EXPERT_NEWS:
      const { enStatus } = action.payload;
      return {
        ...state,
        contributorsData: {
          ...state.contributorsData,
          currentExpert: {
            ...state.contributorsData.currentExpert,
            isLoading: enStatus,
          },
        },
      };
    case GET_NEWS_BY_EXPERT:
      const { ExpertId, listNewsByExpert } = action.payload;
      return {
        ...state,
        contributorsData: {
          ...state.contributorsData,
          currentExpert: {
            ...state.contributorsData.currentExpert,
            expertId: ExpertId,
            expertData: listNewsByExpert,
          },
        },
      };
    case GET_NEWS_FULL_CONTENT:
      const { currentNewsInfo } = action.payload;
      return {
        ...state,
        contributorsData: {
          ...state.contributorsData,
          currentExpert: {
            ...state.contributorsData.currentExpert,
            currentNewsInfo,
          },
        },
      };
    case SET_NEWS_BY_EXPERT_DATA:
      const { newKey, newValue } = action.payload;
      let settingObj = {};
      if (newKey === 'expertId') {
        settingObj = {
          [newKey]: newValue,
          newId: null,
        };
      } else {
        settingObj = {
          [newKey]: newValue,
        };
      }
      const currentExpertClone = {
        ...state.contributorsData.currentExpert,
        ...settingObj,
      };
      return {
        ...state,
        contributorsData: {
          ...state.contributorsData,
          currentExpert: currentExpertClone,
        },
      };
    case SET_FETCHING_C:
      const { cStatus } = action.payload;
      return {
        ...state,
        contributorsData: {
          ...state.contributorsData,
          isLoading: cStatus,
        },
      };

    case GET_MOST_RECENT:
      const { mrData, totalPageMR } = action.payload;
      return {
        ...state,
        mostRecentData: {
          ...state.mostRecentData,
          data: [...state.mostRecentData.data, ...mrData],
          isLoading: false,
          totalPage: totalPageMR,
        },
      };
    case SET_FETCHING_MR:
      const { mrStatus } = action.payload;
      return {
        ...state,
        mostRecentData: {
          ...state.mostRecentData,
          isLoading: mrStatus,
        },
      };

    case GET_MOST_POPULAR:
      const { mpData, totalPageMP } = action.payload;
      return {
        ...state,
        mostPopularData: {
          ...state.mostPopularData,
          data: [...state.mostPopularData.data, ...mpData],
          isLoading: false,
          totalPage: totalPageMP,
        },
      };
    case SET_FETCHING_MP:
      const { mpStatus } = action.payload;
      return {
        ...state,
        mostPopularData: {
          ...state.mostPopularData,
          isLoading: mpStatus,
        },
      };

    case GET_RUMORS:
      const { rData, totalPageR } = action.payload;
      return {
        ...state,
        rumorsData: {
          ...state.rumorsData,
          data: [...state.rumorsData.data, ...rData],
          // data: rData,
          isLoading: false,
          totalPage: totalPageR,
        },
      };

    case SET_FETCHING_R:
      const { rStatus } = action.payload;
      return {
        ...state,
        rumorsData: {
          ...state.rumorsData,
          isLoading: rStatus,
        },
      };
    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
